// extracted by mini-css-extract-plugin
module.exports = {"header":"Component-pepxpress_header__1dscl","info":"Component-pepxpress_info__1a-aQ"};